@if (!isDasboard) {
  <app-table-header
    (reload)="onRefreshList(false)"
    [loading]="loading"
    [withExportOption]="!!data.info.exportTableName"
    (exportBtnClicked)="exportBtnClicked()"
    >
    <div class="to-left">
      @if (showAddButton) {
        <button
          nz-button
          nzType="primary"
          (click)="addEditEventModalComponent.showModal(null)"
          style="margin-right: 10px;"
          >
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
          Neues Ereignis erstellen
        </button>
      }
      <label
        style="margin-right: 10px;"
        nz-checkbox
        [(ngModel)]="filter1"
        (ngModelChange)="filter2 = false; onRefreshList()"
      >Archivierte Ereignisse</label>
      <label
        nz-checkbox
        [(ngModel)]="filter2"
        (ngModelChange)="filter1 = false; onRefreshList()"
      >Aktive Ereignisse</label>
    </div>
    <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
  </app-table-header>
}
<nz-table appColumnLayout id="seminars-events-table"
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzShowPagination]="!isDasboard"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  >
  <thead>
    <tr>
      @if (!isDasboard) {
        <th nzColumnKey="id" [nzShowSort]="!isDasboard" [nzSortFn]="true" nzWidth="75px">#ID</th>
      }
      <th nzColumnKey="name" [nzShowSort]="!isDasboard" [nzSortFn]="true">Name</th>
      <th nzColumnKey="orderNumber" [nzShowSort]="!isDasboard" [nzSortFn]="true">Nummer</th>
      <th nzColumnKey="beginning" [nzShowSort]="!isDasboard" [nzSortFn]="true" nzSortOrder="ascend">Datum und Uhrzeit</th>
      <th nzColumnKey="seats" [nzShowSort]="!isDasboard" [nzSortFn]="true">Sitze</th>
      <th nzColumnKey="attendees.count()" [nzShowSort]="!isDasboard" [nzSortFn]="true">Anzahl der Teilnehmer</th>
      <th nzColumnKey="leader" [nzShowSort]="!isDasboard" [nzSortFn]="true">Leiter</th>
      <th nzColumnKey="comment" [nzShowSort]="!isDasboard" [nzSortFn]="true">Kommentar</th>
      @if (!isDasboard) {
        <th nzColumnKey="isArchived" [nzShowSort]="!isDasboard" [nzSortFn]="true">Archiviert</th>
      }
      <th nzColumnKey="actions" nzRight nzWidth="70px"></th>
    </tr>
  </thead>
  <tbody>
    @for (event of data.results; track event) {
      <tr>
        @if (!isDasboard) {
          <td>{{ event.id }}</td>
        }
        <td>{{ event.name }}</td>
        <td>{{ event.orderNumber }}</td>
        <td>{{ event.beginning | datetimeFormat }}</td>
        <td>{{ event.seats }}</td>
        <td>{{ event.numberOfAttendees }} (freie Plätze: {{ event.seats - event.numberOfAttendees }})</td>
        <td>{{ event.leader }}</td>
        <td>{{ event.comment }}</td>
        @if (!isDasboard) {
          <td>{{ event.isArchived | booleanFormat }}</td>
        }
        <td nzRight>
          <div class="actions">
            @if (!isDasboard) {
              <app-icon-button
                icon="edit"
                [ariaLabel]="'Veranstaltung bearbeiten: ' + event.id"
                (pressed)="addEditEventModalComponent.showModal(event)"
              ></app-icon-button>
            }
            @if (!event.isArchived && !isDasboard) {
              <app-icon-button
                icon="delete"
                [ariaLabel]="'Veranstaltung löschen: ' + event.id"
                confirmTitle="Sind Sie sicher?"
                (confirmed)="archiveEvent(event.id)"
              ></app-icon-button>
            }
            <app-icon-button
              icon="eye"
              [ariaLabel]="'Veranstaltung öffnen: ' + event.id"
              [link]="['/seminars/categories', event.seminar.categoryId, 'seminars', event.seminar.id, 'events', event.id]"
            ></app-icon-button>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>

<app-add-edit-event-modal
  #addEditEventModalComponent
  (refresh)="onRefreshList()"
  [seminar]="seminar"
></app-add-edit-event-modal>
